import React from "react";
import { Link as RRLink, NavLink as RRNavLink, useLocation } from "react-router-dom";
import { isEnglishPath } from "@/config/site";

// Prefixes internal absolute links with /en when the current page is English,
// so every navigation stays within the active language.
const withPrefix = (to, pathname) => {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("/en")) return to;
  if (!isEnglishPath(pathname)) return to;
  return to === "/" ? "/en" : "/en" + to;
};

export const Link = ({ to, ...rest }) => {
  const { pathname } = useLocation();
  return <RRLink to={withPrefix(to, pathname)} {...rest} />;
};

export const NavLink = ({ to, ...rest }) => {
  const { pathname } = useLocation();
  return <RRNavLink to={withPrefix(to, pathname)} {...rest} />;
};
